//Smoothscroll also with page change reload, jumps to top and scrolls down again

//switch off in development, when browser sync is on
//if(document.getElementById('__bs_script__') === null){
    // to top right away
    if ( window.location.hash )scroll(0,0);
// avoid some browsers issues
    setTimeout( function() {
        scroll(0, 0);
    }, 50);

    window.addEventListener('load', function () {
        setTimeout(function () {
            var interactiveComponentTargetDiv = false;
            if(window.location.hash) {
                var target = window.location.hash.substring(1);
                //interactive part
                if ($('.ce-fp-mobile').length > 0 || $('.ce-fp-desktop').length > 0) {
                    if ($('.ce-fp-mobile').length > 0 && window.matchMedia('(max-width: 772px)').matches === true) {
                        interactiveComponentTargetDiv = $('.ce-fp-mobile').find('.ce-fp-mobile__component[data-component="' + target + '"]').first();
                        $('html, body').animate({
                            scrollTop: interactiveComponentTargetDiv.offset().top
                        }, 500, function () {
                            // Add hash (#) to URL when done scrolling (default click behavior)
                            if (history.pushState) {
                                // IE10, Firefox, Chrome, etc.
                                window.history.pushState(null, null, '#' + target);
                            } else {
                                window.location.hash = '#' + target;
                            }
                        });
                    }

                    if ($('.ce-fp-desktop').length > 0 && window.matchMedia('(min-width: 772px)').matches === true) {
                        //check which stage we have to show
                        interactiveComponentTargetDiv = $('.ce-fp-desktop').find('.ce-fp-desktop__lvl2__item[data-component="' + target + '"]').first();
                        //show it
                        if (interactiveComponentTargetDiv.length > 0){
                            interactiveComponentTargetDiv.show();
                            $('.ce-fp-desktop__lvl1').show();
                            interactiveComponentTargetDiv.closest('.lvl-container').fadeIn(function () {
                                var additionalTextDiv = $('.ce-fp-desktop__additional-text').first();
                                additionalTextDiv.html(interactiveComponentTargetDiv.find('.lvl_1_marker__addition').first().html());
                                additionalTextDiv.show();
                            })
                        }
                    }
                }
            }
            //default behavior
            if (window.location.hash && interactiveComponentTargetDiv === false) {
                // smooth scroll to the anchor id
                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top + 'px'
                }, 500,function () {
                    if($(window.location.hash).hasClass('container-accordeon')){
                        $(window.location.hash).find('header button').trigger('click');
                    }
                });
            }
        }, 100);
    });
//}


//smoothscroll for links with hash
$(function() {
    //@fixme avoid to kill standard bs4 functionality like collapse elements
    $("a:not(.bs-btn)").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Store hash
            var hash = this.hash;
            //interactive tool
            var interactiveComponentTargetDiv = false;
            if(hash) {
                var target = hash.substring(1);
                //interactive part
                if ($('.ce-fp-mobile').length > 0 || $('.ce-fp-desktop').length > 0) {
                    if ($('.ce-fp-mobile').length > 0 && window.matchMedia('(max-width: 772px)').matches === true) {
                        interactiveComponentTargetDiv = $('.ce-fp-mobile').find('.ce-fp-mobile__component[data-component="' + target + '"]').first();
                        if (interactiveComponentTargetDiv.length > 0) {
                            if($('body').hasClass('mobi-menu-open')){
                                $('.hamburger').trigger('click');
                            }
                            $('html, body').animate({
                                scrollTop: interactiveComponentTargetDiv.offset().top
                            }, 500, function () {
                                // Add hash (#) to URL when done scrolling (default click behavior)
                                if (history.pushState) {
                                    // IE10, Firefox, Chrome, etc.
                                    window.history.pushState(null, null, '#' + target);
                                } else {
                                    window.location.hash = '#' + target;
                                }
                            });
                        }
                    }

                    if ($('.ce-fp-desktop').length > 0 && window.matchMedia('(min-width: 772px)').matches === true) {
                        //check which stage we have to show
                        interactiveComponentTargetDiv = $('.ce-fp-desktop').find('.ce-fp-desktop__lvl2__item[data-component="' + target + '"]').first();
                        //show it
                        if (interactiveComponentTargetDiv.length > 0){
                            $('.ce-fp-desktop__lvl2__item').hide();
                            interactiveComponentTargetDiv.show();
                            $('.ce-fp-desktop__lvl1').show();
                            interactiveComponentTargetDiv.closest('.lvl-container').fadeIn(function () {
                                var additionalTextDiv = $('.ce-fp-desktop__additional-text').first();
                                additionalTextDiv.html(interactiveComponentTargetDiv.find('.lvl_1_marker__addition').first().html());
                            })
                        }
                    }
                }
            }

            if(interactiveComponentTargetDiv === false || interactiveComponentTargetDiv.length === 0){
                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 500, function() {
                    // Add hash (#) to URL when done scrolling (default click behavior)
                    if (history.pushState) {
                        // IE10, Firefox, Chrome, etc.
                        window.history.pushState(null, null, hash);
                    }else{
                        window.location.hash = hash;
                    }
                    if($(hash).hasClass('container-accordeon')){
                        if($(hash).find('header button').hasClass('collapsed')){
                            $(hash).find('header button').trigger('click');
                        }
                    }
                });
            }
            return false;
        } // End if
    });

});
